import {
  addOptionalNullableToSchema,
  citySchema,
  optionalNameSchema,
  optionalNullableNameSchema,
  phoneSchema,
  requiredErrorMessage,
  streetSchema,
  textSchema,
  zipSchema,
} from '@common/schema';
import * as yup from 'yup';

export const editPatientSchema = yup.object().shape({
  lives_at_home: yup
    .string()
    .oneOf(['true', 'false'])
    .required(requiredErrorMessage),

  building_id: yup
    .string()
    .when('lives_at_home', ([lives_at_home], schema) =>
      lives_at_home === 'false'
        ? schema.required(requiredErrorMessage)
        : yup.string().strip(),
    ),
  building_unit: yup
    .string()
    .when('lives_at_home', ([lives_at_home], schema) =>
      lives_at_home === 'false'
        ? schema
            .required(requiredErrorMessage)
            .oneOf(
              [
                'assisted_living',
                'memory_care',
                'senior_living',
                'independent_living',
              ],
              requiredErrorMessage,
            )
        : yup.string().strip(),
    ),
  room: optionalNameSchema,
  phone_number: addOptionalNullableToSchema(phoneSchema),
  fax_number: addOptionalNullableToSchema(phoneSchema),

  google_places_id: addOptionalNullableToSchema(yup.string()),
  state: textSchema.when('lives_at_home', ([lives_at_home], schema) =>
    lives_at_home === 'true'
      ? schema.required(requiredErrorMessage)
      : yup.string().strip(),
  ),
  city: citySchema.when('lives_at_home', ([lives_at_home], schema) =>
    lives_at_home === 'true'
      ? schema.required(requiredErrorMessage)
      : yup.string().strip(),
  ),
  street: streetSchema.when('lives_at_home', ([lives_at_home], schema) =>
    lives_at_home === 'true'
      ? schema.required(requiredErrorMessage)
      : yup.string().strip(),
  ),
  suite: optionalNullableNameSchema,
  zip_code: zipSchema.when('lives_at_home', ([lives_at_home], schema) =>
    lives_at_home === 'true'
      ? schema.required(requiredErrorMessage)
      : yup.string().strip(),
  ),
  county: optionalNullableNameSchema,
  country: textSchema.when('lives_at_home', ([lives_at_home], schema) =>
    lives_at_home === 'true'
      ? schema.required(requiredErrorMessage)
      : yup.string().strip(),
  ),
  full_address_line: yup.string().optional(),
});
